import { createReducer } from '@reduxjs/toolkit';
import { getAnalyticsToken } from 'redux/actions/analytics';
import { normalize } from 'normalizr';
import { QrveyState } from 'redux/schemas/models/course';
import { string } from 'yargs';
import { AnalyticsDashBoardType } from 'redux/schemas/app/analytics';
import { initialRootState } from '.';

export const initialQrveyState: QrveyState = {
  isLoading: false,
  appId: '',
  host: '',
  token: '',
  userId: '',
  type: AnalyticsDashBoardType.UNSET,
  journeyName: '',
};
export default createReducer(initialRootState, builder => {
  builder

    .addCase(getAnalyticsToken.fulfilled, (state, action) => {
      const { appId, host, token, userId, journey } = action.payload;
      state.app.qrveyConfig = { appId, host, token, userId, type: action.meta.arg.type, isLoading: false };
      if (journey) {
        state.app.qrveyConfig.journeyName = journey.name;
      }
    })
    .addCase(getAnalyticsToken.pending, (state, action) => {
      state.app.qrveyConfig.isLoading = true;
    });
});
